(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StorageManagementPlanController', StorageManagementPlanController);

    StorageManagementPlanController.$inject = ['$uibModalInstance', 'StroageService', 'MessageService', '$timeout', '$rootScope'];

    function StorageManagementPlanController ($uibModalInstance, StroageService, MessageService, $timeout, $rootScope) {
        var vm = this;
        vm.clear = clear;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
